import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Tooltip from './common/Tooltip';

const formatFailedStatus = (status) => {
  if (!status) return 'excluded';
  return status
    .toString()
    .toLowerCase()
    .replace(/^failed_?/, '')
    .replace(/_/g, ' ');
};

const FailedTransactionWarning = ({ transaction, className = '' }) => {
  if (!transaction?.failedStatus) return null;

  const tooltip = `Excluded from position calculation: ${formatFailedStatus(transaction.failedStatus)}`;

  return (
    <Tooltip title={tooltip} position="top" trigger="mouseenter focus" arrow={true} distance={8}>
      <span
        className={`inline-flex items-center text-amber-500 dark:text-amber-400 ${className}`}
        aria-label={tooltip}
      >
        <FaExclamationTriangle className="w-3.5 h-3.5" />
      </span>
    </Tooltip>
  );
};

export default FailedTransactionWarning;
